import React from 'react';
import styled from '@emotion/styled';
import { connectStats, connectCurrentRefinements } from 'react-instantsearch-dom';
import { formatNumber } from 'accounting-js';
import PropTypes from 'prop-types';

import { Heading } from './left-rail-shared';
import { cleanUpFacets, getTotalActiveFilters } from './utils/refinementHelpers';

const RefinementHeading = styled(Heading)(({ theme, hasActiveFilters }) => ({
  borderBottom: hasActiveFilters ? 'none !important' : undefined,
  lineHeight: hasActiveFilters ? theme.modularScale.sixteen : '5rem',
  marginBottom: hasActiveFilters ? '1rem' : '0',
  [`@media screen and (max-width: ${theme.breakpoint.medium})`]: {
    lineHeight: theme.modularScale.sixteen,
    marginTop: '4rem',
    marginBottom: '1rem' // Magic number to account for the 3rem height of the actual <p> Refinement value
  }
}));

const RefinementItemsNum = styled.span`
  font-family: ${({ theme }) => theme.font.sans};
`;

const RefinementsHead = connectCurrentRefinements(({ nbHits, items }) => {
  const { totalActiveFilters } = getTotalActiveFilters(items);

  return (
    <RefinementHeading
      role="heading"
      aria-level="2"
      element="label"
      like="label-1"
      hasActiveFilters={totalActiveFilters > 0}
    >
      { totalActiveFilters > 0 ? `Filters (${totalActiveFilters})` : 'Filters' }
      <RefinementItemsNum>{`${formatNumber(nbHits, { precision: 0 })} items`}</RefinementItemsNum>
    </RefinementHeading>
  );
});

RefinementsHead.defaultProps = {
  nbHits: 0,
  items: []
};

RefinementsHead.propTypes = {
  nbHits: PropTypes.number,
  items: PropTypes.array
};

const RefinementsHeader = (props) => {
  const removeHiddenFacets = cleanUpFacets(props.isBrandRefined);

  return (
    <RefinementsHead
      {...props}
      transformItems={removeHiddenFacets}
    />
  );
};

RefinementsHeader.defaultProps = {
  isBrandRefined: false
};

RefinementsHeader.propTypes = {
  isBrandRefined: PropTypes.bool
};

export default connectStats(RefinementsHeader);
